'use strict';

const _ = require('underscore');

export const IS_NODE = process.env.IS_NODE;
